import './style.css';

import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from '@vis.gl/react-google-maps';
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import type { MarkerPressEvent } from 'react-native-maps';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

export interface CarMarkerProps {
  latitude: number;
  longitude: number;
  icon?: React.ReactNode;
  text?: string;
  onPress?: (e: MarkerPressEvent) => void;
  active?: boolean;
  infoWindow?: React.ReactNode;
}

export default function CarMarker({
  latitude,
  longitude,
  icon,
  text,
  onPress,
  active = false,
  infoWindow,
}: CarMarkerProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);
  const [markerRef, marker] = useAdvancedMarkerRef();
  const [infoWindowShown, setInfoWindowShown] = useState(false);

  useEffect(() => {
    setInfoWindowShown(active);
  }, [active]);

  const getStyle = () => {
    let stateStyle = styles.default;

    if (active) {
      stateStyle = styles.active;
    }

    if (hover) {
      stateStyle = styles.hover;
    }

    return [styles.marker, stateStyle];
  };

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={{
          lat: latitude,
          lng: longitude,
        }}
        onClick={(e) => {
          setInfoWindowShown((isShown) => !isShown);
          onPress?.({
            latitude: e.latLng.lat(),
            longitude: e.latLng.lng(),
          });
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <View style={[getStyle()]}>
          {icon ? icon : null}

          {text ? <Text type="bodyBold">{text}</Text> : null}
        </View>
      </AdvancedMarker>

      {infoWindow && infoWindowShown && (
        <InfoWindow
          anchor={marker}
          onClose={() => {
            setInfoWindowShown(false);
          }}
          headerDisabled={true}
        >
          {infoWindow}
        </InfoWindow>
      )}
    </>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  marker: {
    borderRadius: 100,
    borderWidth: 2,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 4,
    paddingBottom: 4,
  },
  default: {
    backgroundColor: theme.colors.carMarker.default.backgroundColor,
    borderColor: theme.colors.carMarker.default.border,
  },
  hover: {
    backgroundColor: theme.colors.carMarker.hover.backgroundColor,
    borderColor: theme.colors.carMarker.hover.border,
  },
  active: {
    backgroundColor: theme.colors.carMarker.active.backgroundColor,
    borderColor: theme.colors.carMarker.active.border,
  },
}));
